import {makeStyles} from "@material-ui/core";

export const useMainDialogContentStyles = makeStyles(() => ({
    banner: {
        backgroundColor: "#fdf2e3",
        margin: "-16px -16px 0 -16px",
        minHeight: "54px",
        display: "flex"
    },
    textBanner: {
        alignSelf: "center",
        marginLeft: "0.5em"
    },
    bannerIcon: {
        alignSelf: "center",
        marginLeft: "0.75em"
    }
}));
